// extracted by mini-css-extract-plugin
export default {"melodyVideo":"UM-z","isFullWidth":"VM-z","landingPageVideo":"WM-z","play":"XM-z","iframeVideo":"YM-z","playHidden":"ZM-z","fullwidth":"_M-z"};